import { GraphNode } from '../graph-node.js';
/** Branch is the one implemented node whose exec pins break the `exec` / `on…` naming. */
const BRANCH_EXEC_OUT_PORT_KEYS = new Set(['true', 'false']);
export class BranchNode extends GraphNode {
    constructor(id, data, type) {
        super(id, data, type);
    }
    isExecOutPort(outPortKey) {
        if (BRANCH_EXEC_OUT_PORT_KEYS.has(outPortKey))
            return true;
        return super.isExecOutPort(outPortKey);
    }
    run() {
        super.run();
        const condition = this.data.condition;
        if (condition) {
            this.triggerOutPort('true');
        }
        else {
            this.triggerOutPort('false');
        }
    }
}
